/** Canonical Carma contact values shared across apps and UI. */
export const CARMA_PHONE_NUMBER = '+61283193210';
export const CARMA_WHATSAPP = 'https://wa.me/61485854551';
